import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handlers } from '../../helpers/helpers';
import statusDictionary from '../../helpers/statusDictionary.json';
import { patientsService } from '../../services/patient';

const useGetLocalStorageData = ({ countryCode }) => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState();
  const [hasSurvey, setHasSurvey] = useState();
  const [batteries, setBatteries] = useState();
  const [surveyExam, setSurveyExam] = useState();
  const [loading, setLoading] = useState();
  const [goToTabs, setGoToTabs] = useState();
  const [error, setError] = useState();
  const [goToSurvey, setGoToSurvey] = useState();

  const goToSurveyClick = useCallback(() => {
    setLoading(true);
    patientsService.getPatientSurveys({
      admission_patient_exam_id: surveyExam.admission_patient_exam_id,
      exam_code: surveyExam.code,
    }).then((response) => {
      if (!localStorage.getItem('surveyData')) {
        handlers.handleSurveyData({
          surveys: response,
          admission_patient_exam_id: surveyExam.admission_patient_exam_id,
          exam_code: surveyExam.code,
          exam_name: surveyExam.name,
        })
      }
      handlers.handleUserData({ ...userData, tabs: true })
    }).catch(error => {
      setError(error)
    })
      .finally(() => {
        navigate(`/mis-examenes/${countryCode}/encuesta-salud`);
        setLoading(false);
      })
  }, [countryCode, navigate, surveyExam, userData])

  const continueButtonHandler = useCallback(() => {
    if (hasSurvey) {
      setLoading(true);
      patientsService.getPatientSurveys({
        admission_patient_exam_id: surveyExam.admission_patient_exam_id,
        exam_code: surveyExam.code,
      }).then((response) => {
        handlers.handleSurveyData({
          surveys: response,
          admission_patient_exam_id: surveyExam.admission_patient_exam_id,
          exam_code: surveyExam.code,
          exam_name: surveyExam.name,
        })
        handlers.handleUserData({ ...userData, tabs: true })
      }).catch(error => {
        setError(error)
      })
        .finally(() => {
          setLoading(false);
          navigate(`/mis-examenes/${countryCode}/encuesta-salud`);
        })
    } else {
      handlers.handleUserData({ ...userData, tabs: true });
      setGoToTabs(true);
    }
  }, [hasSurvey, surveyExam, countryCode, navigate, userData])

  useEffect(() => {
    setUserData();
    setLoading();
    setGoToTabs();
    setSurveyExam();
    setHasSurvey();
    setGoToSurvey();
  }, []);

  const getExamsOfDay = useCallback(() => {
    setLoading(true);
    const data = JSON.parse(localStorage.getItem('userData'));
    const surveyData = JSON.parse(localStorage.getItem('surveyData'));

    patientsService.getExamsOfDay({
      document_type: data.document_type, document_number: data.document_number
    })
      .then(response => {
        if (response.consultations || response.exams) {
          setUserData({ ...response, tabs: data.tabs, current_step: data.current_step });
          handlers.handleUserData({ ...response, tabs: data.tabs, current_step: data.current_step });

          if (surveyData?.back_to_exams === false) {
            setGoToSurvey(true)
          }
        } else {
          setError('Tus datos no registran documentos para rellenar');
        }
      })
      .catch(error => {
        setError(error)
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('userData'));

    if (data) {
      getExamsOfDay();
    } else {
      navigate(`/mis-examenes/${countryCode}`);
    }

  }, [navigate, countryCode, getExamsOfDay]);

  useEffect(() => {
    if (userData?.exams) {
      const surveyExamToSearch = userData.exams.find((exam) => {
        return exam.has_survey && exam.state !== statusDictionary.done.status && (exam.state !== statusDictionary.occupied.status || (exam.state === statusDictionary.occupied.status && exam.has_survey));
      })

      if (surveyExamToSearch) {
        setHasSurvey(true);
        setGoToTabs(false);
        handlers.handleUserData({ ...userData });

        setSurveyExam(surveyExamToSearch);

        if (goToSurvey) {
          navigate(`/mis-examenes/${countryCode}/encuesta-salud`);
        }
      } else {
        setHasSurvey(false);
        setSurveyExam();
      }

      if (userData.tabs || !surveyExamToSearch) {
        setGoToTabs(true);
        handlers.handleUserData({ ...userData, tabs: true });
      }
    }

    if (userData?.batteries) {
      setBatteries(userData.batteries);
    }
  }, [userData, goToSurvey, countryCode, navigate, goToTabs, setGoToTabs, surveyExam]);

  return {
    userData,
    hasSurvey,
    batteries,
    continueButtonHandler,
    loading,
    goToTabs,
    goToSurveyClick,
    surveyExam,
    getExamsOfDay,
  };
}

export default useGetLocalStorageData;
